// extracted by mini-css-extract-plugin
module.exports = {"foolScreen":"NewFoolScreen_foolScreen__2F7-Q","subscribersBlock":"NewFoolScreen_subscribersBlock__2lkn6"};